<template>
  <div id="PetCardSection">
    <section class="pet-credentials">
      <div class="profile-info-card">
        <div class="profile-image-group">
          <div
            class="profile-image"
            :style="{
              'background-image': 'url(' + pet_data.photo + ')',
            }"
          >
            <div
              v-if="pet_data.location.address"
              class="profile-image-country"
              :style="{ 'background-image': 'url(' + getCountryFlag() + ')' }"
            ></div>
            <input
              v-if="editablePage"
              class="profile-input"
              type="file"
              accept="image/jpeg, image/png, image/gif"
              @change="selectProfileFile"
              value="0"
            />

            <div class="profile-img-overlay">
              <p>Click To Edit Photo</p>
            </div>
          </div>
          <div v-if="editablePage">
            <img
              class="tag-icons"
              :src="checked_icon"
              v-if="pet_data.tag_links.length > 0"
            />
            <img class="tag-icons" :src="caution_icon" v-else />
          </div>
        </div>
        <div class="profile-details-section">
          <div class="profile-details-name">
            <h2>{{ pet_data.name }}</h2>
            <p class="parent">
              Parent:
              <span class="text-primary"> {{ displayUser }}</span>
            </p>
            <div class="profile-details-address">
              <img
                class="address-icon"
                src="@/assets/svg/pet-card-icon/location-colored.svg"
              />
              <p class="address-text-truncate">
                {{ userLocationFmt }}
              </p>
            </div>
          </div>
          <div class="report-lost-btn processing-report" v-if="processing">
            Please Wait
          </div>
          <div
            role="button"
            v-if="!processing"
            @click="manageReportLost()"
            class="report-lost-btn"
          >
            REPORT LOST
          </div>
        </div>
      </div>

      <div class="btn-group" :class="{ 'gv-btn-group': editablePage == false }">
        <button
          v-if="editablePage"
          class="allergy-pod"
          @click="activeChange()"
          :class="{
            'public-pod': userdata.settings.showContactInfo,
            'private-pod': !userdata.settings.showContactInfo,
          }"
        >
          <span
            class="allergy-pod-text"
            v-if="userdata.settings.showContactInfo"
          >
            <img src="@/assets/icons/eye.svg" />
            <p>Public</p>
          </span>

          <span class="allergy-pod-text" v-else>
            <img src="@/assets/icons/eye-closed.svg" />
            <p>Private</p>
          </span>

          <div
            class="visibility-popup"
            :class="{ 'visibility-active': changedInfo }"
          >
            <p>
              Your Address is
              <span v-if="userdata.settings.showContactInfo">Public</span>
              <span v-else>Private</span>
            </p>
          </div>
        </button>

        <div
          class="more-menu-overlay"
          v-if="showMoreOptions"
          @click="showMoreOptionMenu(false)"
        ></div>

        <div
          class="more-menu-area"
          v-show="false"
          :class="{ 'menu-open': showMoreOptions }"
        >
          <div
            class="more-icon-menu"
            v-if="showMoreOptions"
            @mouseover="showMoreOptionMenu(true)"
            @mouseleave="showMoreOptionMenu(false)"
            :class="{ 'guest-menu': editablePage == false }"
          >
            <ul>
              <li @click="toggleViewType()" v-if="editablePage">
                View Guest Mode
              </li>
              <li @click="copyProfileLink()">Share Pet Profile</li>
              <li v-if="editablePage">
                <div
                  class="edit-allergies"
                  @click="toggleEditPetModal()"
                  v-if="editablePage"
                >
                  Edit Pet
                </div>
              </li>
              <li
                v-if="editablePage"
                class="delete-link"
                @click="toggleDeleteModal()"
              >
                Delete Pet
              </li>
            </ul>
          </div>

          <button
            class="more-options"
            @click="showMoreOptionMenu(!showMoreOptions)"
          >
            <img src="@/assets/svg/pet-card-icon/option3.svg" />
          </button>
        </div>
      </div>

      <div class="about-section">
        <div class="about-header">
          <h2 class="about-header-text">About {{ pet_data.name }}</h2>
          <button class="edit-about" @click="toggleAbout()" v-if="editablePage">
            <img v-if="!editAbout" src="@/assets/svg/pet-card-icon/edit.svg" />
            <span class="x-close" v-else>&times;</span>
          </button>
        </div>
        <textarea
          class="pet-notes"
          :placeholder="aboutPlaceholder"
          v-model="pet_data.notes"
          v-if="editablePage"
          :class="{ active: editAbout }"
        >
        </textarea>
        <XyzTransition xyz="fade down-100% back-5">
          <button v-if="editAbout" class="btn save-btn" @click="saveNote()">
            Save
          </button>
        </XyzTransition>

        <div class="pet-notes gv-notes" v-if="!editablePage">
          <p v-if="pet_data.notes != ''">
            <span v-if="!showFullNotes">
              {{ pet_data.notes.split("").slice(0, 255).join("") }}...<span
                v-if="pet_data.notes.length > 255 && !showFullNotes"
                class="notes-more-less"
                @click="showFullNotes = true"
                >Read More</span
              >
            </span>
            <span v-else>
              {{ pet_data.notes }}
              <span
                v-if="pet_data.notes.length > 255 && showFullNotes"
                class="notes-more-less"
                @click="showFullNotes = false"
                >Show Less</span
              >
            </span>
          </p>
          <p v-else>
            {{ userdata.fname || userdata.username }} has not said anything
            about {{ pet_data.name }} yet!
          </p>
        </div>
      </div>
    </section>

    <section class="pet-attributes profile-details">
      <div class="pet-attributes-section">
        <div class="pet-attributes-group">
          <div class="pet-attributes-heading">Gender</div>
          <div class="pet-attributes-value">
            {{ pet_data.gender }}
          </div>
        </div>
        <div class="pet-attributes-group">
          <div class="pet-attributes-heading">Age</div>
          <div class="pet-attributes-value">
            {{ displayPetAge.display_age }}&nbsp;{{
              displayPetAge.display_age_postfix
            }}
          </div>
        </div>
        <div class="pet-attributes-group">
          <div class="pet-attributes-heading">Pet Type</div>
          <div class="pet-attributes-value">
            {{ pet_data.species }}
          </div>
        </div>
        <span class="pet-attributes-devider-left"></span>
        <span class="pet-attributes-devider-right"></span>
      </div>
    </section>

    <!-- Pet attributes -->
    <section
      class="profile-details"
      v-if="filtered_profile_details && filtered_profile_details.length > 0"
    >
      <div class="width-90">
        <div class="pet-grid border-grey">
          <div
            class="pet-info bg-white"
            v-for="(pd, idx) in filtered_profile_details"
            :key="idx"
            @click="attributeAction(pd.action)"
          >
            <div class="visible-pet-info">
              <p
                :class="{
                  'pet-attributes-heading-gray': true,
                  'size-reduce': pd.vari == 'breed' && pd.label.length > 9,
                }"
              >
                {{ pd.label }}
              </p>
              <p class="pet-attributes-value-medium">
                {{ pd.value.trim() }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

        <section class="pet-socials">
            <div class="profile-details">
                <div class="btn-group-full-width" v-if="pet_data.settings_privacy.showSocials && pet_data.link_instagram != ''" @click="gotoInstagram()">
                    <div role="button" class="btn-full-width btn-instagram">
                        <div class="btn-section">
                            <div class="icon">
                                <img
                                    src="@/assets/svg/pet-card-icon/instagram-colored.svg"
                                />
                            </div>
                            <div class="btn-left-text">
                                <p>Instagram</p>
                                <h2
                                >
                                    @{{ pet_data.link_instagram || "heybuddy.club" }}
                                </h2>
                            </div>
                        </div>
                        <div class="btn-section">
                            <div class="icon">
                                <svg
                                    width="8"
                                    height="14"
                                    viewBox="0 0 8 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1 13L7 7L1 1"
                                        stroke="white"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-group-full-width" v-if="pet_data.settings_privacy.showSocials && pet_data.link_tiktok != ''" @click="gotoTiktok()">
                        <div role="button" class="btn-full-width btn-tiktok">
                        <div class="btn-section">
                            <div class="icon">
                                <img
                                    src="@/assets/svg/pet-card-icon/tiktok-colored.svg"
                                />
                            </div>
                            <div class="btn-left-text">
                                <p>TikTok</p>
                                <h2
                                >
                                    @{{ pet_data.link_tiktok || "heybuddy.club" }}
                                </h2>
                            </div>
                        </div>
                        <div class="btn-section">
                            <div class="icon">
                                <svg
                                    width="8"
                                    height="14"
                                    viewBox="0 0 8 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1 13L7 7L1 1"
                                        stroke="white"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="btn-group-full-width"
                    @click="gotoHealth()"
                    v-if="pet_data.settings_privacy.showHealth"
                >
                    <div role="button" class="btn-full-width btn-health">
                        <div class="btn-section">
                            <div class="icon">
                                <img
                                    src="@/assets/svg/pet-card-icon/health-colored.svg"
                                />
                            </div>
                            <div class="btn-left-text">
                                <h2>Health</h2>
                            </div>
                        </div>
                        <div class="btn-section">
                            <div class="icon">
                                <svg
                                    width="8"
                                    height="14"
                                    viewBox="0 0 8 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1 13L7 7L1 1"
                                        stroke="white"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    <section class="pet-grid" v-if="editablePage">
      <div>
        <button
          class="red-alert pet-info"
          @click="toggleMissingPetModal(true)"
          v-if="
            triggerAlert ||
            !pet_data.alertExpiration ||
            pet_data.alertExpiration < 0
          "
        >
          <img src="@/assets/icons/siren.svg" />
          ALERT
        </button>
        <button class="red-alert unactive" v-else>
          <img src="@/assets/svg/pet-card-icon/info-circle.svg" />
          You have
          {{
            (timeUntilReactivation(pet_data.alertExpiration) / 86400).toFixed(0)
          }}
          days until this button is active again
        </button>
      </div>
      <div class="">
        <button
          class="red-alert pet-info unactive2"
          @click="toggleMissingFlyerModal(true)"
        >
          <img src="@/assets/icons/printing.svg" />
          Pet Flyer
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { fb, db } from "@/_firebase/init";
import { mapState, mapGetters, mapMutations } from "vuex";
// import Cookies from 'js-cookie';

// import countries from './countries.json';
import countries from "@/assets/json/countries.json";

export default {
    name: "PetCardSection",
    components: {},
    props: ["userdata", "editablePage"],
    data() {
        return {
            pet_id: this.$route.params.pet_id,
            location: null,
            processing: false,
            editAbout: false,
            actionPending: false,
            showConfirmModal: false,
            showMoreOptions: false,
            showMissingPetModal: false,
            changedInfo: false,
            showSettings: true,
            shakeImgs: false,
            isScanning: false,
            pets_owned: [],
            showFullNotes: false,
            countries:countries,
            profile_details: [
                {
                    icon: require("@/assets/svg/pet-card-icon/pawprint.svg"),
                    value: "",
                    label: "Breed",
                    suffix: "",
                    vari: "breed",
                    action: "",
                    isPrivate: false,
                    clickable: false,
                },
                {
                    icon: require("@/assets/svg/pet-card-icon/pawprint.svg"),
                    value: "",
                    label: "Breed",
                    suffix: "",
                    vari: "breed",
                    action: "",
                    isPrivate: false,
                    clickable: false,
                },
                {
                    icon: require("@/assets/svg/pet-card-icon/birthday.svg"),
                    value: "",
                    label: "Pet Birthday",
                    suffix: "",
                    vari: "",
                    action: "change_age",
                    isPrivate: false,
                    clickable: true,
                },
                {
                    icon: "",
                    label: "Weight",
                    suffix: "",
                    vari: "weight",
                    value: "",
                    action: "",
                    isPrivate: false,
                    clickable: false,
                },
                {
                    icon: require("@/assets/svg/pet-card-icon/microchip.svg"),
                    value: "",
                    label: "Microchip #",
                    suffix: "",
                    vari: "",
                    action: "microchip",
                    isPrivate: false,
                    clickable: false,
                },
                {
                    icon: require("@/assets/svg/pet-card-icon/syringe.svg"),
                    value: "",
                    label: "Rabies Vaccination",
                    suffix: "",
                    vari: "",
                    action: "vaccinate",
                    isPrivate: false,
                    clickable: false,
                },
                {
                    icon: "",
                    label: "Behavior",
                    suffix: "",
                    vari: "",
                    action: "",
                    value: "",
                    isPrivate: false,
                    clickable: false,
                },
                {
                    icon: "",
                    label: "Pet License",
                    suffix: "",
                    vari: "",
                    action: "",
                    value: "",
                    isPrivate: false,
                    clickable: false,
                },
                {
                    icon: "",
                    label: "Rabies Vacc. #",
                    suffix: "",
                    vari: "",
                    action: "rabi_vaccination",
                    value: "",
                    isPrivate: false,
                    clickable: false,
                },
            ],
            notesLines:0,
            owner_name: "",
            default_photo: require("@/assets/icons/missing.svg"),
            // pet_data:{photo:'', name: '', gallery:[], tag_links:[]},
            loading: true,
            checked_icon: require("@/assets/svg/pet-card-icon/device-activated.svg"),
            caution_icon: require("@/assets/svg/pet-card-icon/warning.svg"),
            // : {}
            interval_count: 0,
            filtered_profile_details: [],
        };
    },
    methods: {
        ...mapMutations(["SET_PETDATA", "SET_CURRENT_LOCATION"]),
        manageReportLost() {
            this.processing = true;
            if (this.current_location.latitude != null) {
                this.reportLost();
            } else {
                this.getLocation();
            }
        },
        getCountryFlag(){
            if(!this.pet_data.location.address.country){
                return require(`@/assets/svg/flags/_.svg`)
            }
            return require(`@/assets/svg/flags/${this.countries[this.pet_data.location.address.country].code}.svg`)
        },
        getLocation() {
            if (!("geolocation" in navigator)) {
                this.errorStr = "Geolocation is not available.";
                return;
            }
            this.gettingLocation = true;
            console.log("getting location");
            navigator.geolocation.getCurrentPosition(
                pos => {
                    console.log(pos);
                    let lat = pos.coords.latitude;
                    let long = pos.coords.longitude;
                    this.location = { latitude: lat, longitude: long };
                    this.SET_CURRENT_LOCATION({ lat, long });
                    this.reportLost();
                },
                err => {
                    console.log(err);
                    this.reportLost();
                },
                { timeout: 10000 }
            );
        },
        reportLost() {
            const config = {
                headers: {
                    api_key: 'wNZkAJcXnMTOKnRH-eEAHcoNWmI4xmGXl-54MlVlI2hIFJWBxc-vunkFCgjKMOMLAz2',
                    petID: this.pet_id,
                },
            };
            let payload = {
                coodinates: { latitude: null, longitude: null },
            };
            if (this.current_location != { latitude: null, longitude: null }) {
                payload["coodinates"] = this.current_location;
            }
            if (this.location != null) {
                payload["coodinates"] = this.location;
            }

      console.log(payload);
      axios
        .post(this.$main_api + "pets/report_lost", payload, config)
        .then((res) => {
          console.log(res.data);
          this.processing = false;
        })
        .catch((err) => {
          console.log(err);
          this.processing = false;
        });
    },
    attributeAction(action) {
      this.actionPending = true;
      if (action == "change_age") {
        this.profile_details[0].value = `${this.pet_data.bday}`;
        // setTimeout(()=>{
        //   let display_age = this.petAge ? this.petAge > 0 : '< 1'
        //   this.profile_details[0].label = `${display_age} years old`
        // }, 3000);http://localhost:8080/pet/O6kJDNxwOZCYPr6nlSos/healthmicrochip
        // console.log(action)
      }

      if (action == "instagram") {
        if (this.pet_data.link_instagram == "") {
          window.open(`http://www.instagram.com/heybuddy.club`);
        }
        window.open(`http://www.instagram.com/${this.pet_data.link_instagram}`);
        console.log(action);
      }
      if (this.editablePage) {
        if (action == "microchip") {
          this.$router.push({
            name: "PetHealth",
            params: { pet_id: this.pet_id },
            hash: "#microchip",
          });
        }

        if (action == "vaccinate") {
          this.pet_data.isVaccinated = !this.pet_data.isVaccinated;
          this.profile_details[4].value = this.pet_data.isVaccinated
            ? "YES"
            : "NO";
          this.saveVaccinationStatus();
        }
      }
    },
    async saveVaccinationStatus() {
      //deprecated
      // hasAllergies
      await db.collection("pets").doc(this.pet_id).update(this.pet_data);
      this.SET_PETDATA(this.pet_data);
    },
    async saveNote() {
      //deprecated
      this.editAbout = false;
      await db.collection("pets").doc(this.pet_id).update(this.pet_data);
      this.SET_PETDATA(this.pet_data);
    },
    toggleMissingPetModal(val) {
      this.$emit("toggleMissingPetModal", val);
    },
    toggleMissingFlyerModal(val) {
      this.$emit("toggleMissingFlyerModal", val);
    },
    activeChange() {
      this.changedInfo = true;
      this.userPublicSettings();
      setTimeout(() => {
        this.changedInfo = false;
      }, 750);
    },
    async userPublicSettings() {
      this.userdata.settings.showContactInfo =
        !this.userdata.settings.showContactInfo;
      const data = this.userdata;
      await db.collection("users").doc(this.userID).update(data);
      // console.log(this.userdata.settings.showContactInfo)
    },
    copyProfileLink() {
      const link = `https://app.heybuddy.club/u/${this.userdata.username}/pet/${this.pet_id}`;
      navigator.clipboard.writeText(link);
      if (navigator.canShare) {
        navigator.share({
          url: `https://app.heybuddy.club/u/${this.userdata.username}/pet/${this.pet_id}`,
          title: "HeyBuddy",
          text: ``,
        });
      }
    },
    toggleViewType() {
      this.$emit("toggleViewType", false);
    },
    petTrigger() {
      window.open(`https://www.instagram.com/{}`, "_blank");
    },
    toggleAbout() {
      this.editAbout = !this.editAbout;
    },
    // ...mapMutations(['SET_PETDATA']),
    toggleEditPetModal() {
      // this.shakeImgs = !this.shakeImgs
      this.$emit("toggleEditPetModal", true);
    },
    toggleDeleteModal() {
      this.$emit("toggleDeleteModal", true);
    },
    gotoHealth() {
      const username = this.$route.params.username;
      window.open(`/u/${username}/pet/${this.pet_id}/health`, "_self");
    },
    gotoInstagram() {
      if (this.pet_data.link_instagram == "") {
        window.open(`http://www.instagram.com/heybuddy.club`);
      } else {
        window.open(`http://www.instagram.com/${this.pet_data.link_instagram}`);
      }
    },
    gotoTiktok() {
      if (this.pet_data.link_tiktok === "") {
        window.open(`https://www.tiktok.com/@heybuddy.club`);
      } else {
        window.open(`https://www.tiktok.com/@${this.pet_data.link_tiktok}`);
      }
    },
    showMoreOptionMenu(val) {
      this.showMoreOptions = val;
    },
    selectProfileFile(evt) {
      let file = evt.target.files[0];
      var storeRef = fb.storage().ref("/pet_profile_media/photo/" + file.name);
      let uploadTask = storeRef.put(file);
      uploadTask.on(
        "state_changed",
        () => {},
        (err) => {
          console.log(err);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            this.pet_data.photo = downloadURL;

            this.SET_PETDATA(this.pet_data);
            this.updateDataPhoto(downloadURL);
          });
        }
      );
    },
    async updateDataPhoto(photo_url) {
      //deprecated
      const petRef = db.collection("pets").doc(this.pet_id);
      await petRef.update({
        photo: photo_url,
      });
    },
    changeTrigger(val) {
      this.triggerAlert = val;
    },
    timeUntilReactivation(expired_time) {
      const now = new Date();
      const utc_epoch = Math.round(now.getTime() / 1000);
      return expired_time - utc_epoch;
    },
    gotoRoute(rotue) {
      this.$router.push({ name: rotue });
    },
    async getPetData() {
        try {
            const res = await axios.get(`${this.$api_path}/pets/${ this.pet_id}/guest`)
            this.pet_data = res.data.result;
            // console.log("section guest", res.data)

            if (!this.pet_data.photo) {
                this.pet_data.photo = this.default_photo;
            }

            this.initPetAttributes();
        } catch (error) {
            console.error("Error fetching pet data from API:", error);
        }
    },
    capitalizeFirstLetter(string) {
      if (!string) {
        return null;
      }
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    initPetAttributes() {
      const bday = this.pet_data.bday.split("/");
      if (bday && bday.length === 3) {
        let formattedBday = this.pet_data.bday;
        if (this.pet_data.date_fmt) {
          formattedBday = this.pet_data.date_fmt
            .toLowerCase()
            .replace("mm", bday[0])
            .replace("dd", bday[1])
            .replace("yyyy", bday[2]);
        }

        this.profile_details[2].value = formattedBday;
        this.profile_details[2].isPrivate = false;
      }

      // Breed
      this.profile_details[0].value = this.capitalizeFirstLetter(
        this.pet_data.breed
      );
      this.profile_details[0].isPrivate = false;

      if (this.pet_data.breed2) {
        // Breed
        this.profile_details[1].value = `${this.capitalizeFirstLetter(
          this.pet_data.breed2
        )}`;
        this.profile_details[1].isPrivate = false;
      }

      //Weight
      if (this.pet_data.weight) {
        let weight = this.pet_data.weight;

        if (
          this.pet_data.weight_type &&
          this.pet_data.weight_type.toLowerCase().includes("kg")
        ) {
          weight = this.pet_data.weight / 2.20462262185;
        }
        this.profile_details[3].value = `${
          weight >= 1 ? Math.round(weight) : weight.toFixed(1)
        } ${this.pet_data.weight_type || "lbs"}`;
        this.profile_details[3].isPrivate = false;
      }

      //microchipp
      this.profile_details[4].value = this.pet_data.microchip_number;
      this.profile_details[4].isPrivate = false;

      //Behaviour
      this.profile_details[6].value = this.pet_data.behavior;
      this.profile_details[6].isPrivate = false;

      //License
      this.profile_details[7].value =
        this.pet_data.license && this.pet_data.license.number;
      this.profile_details[7].isPrivate = false;

      //rabies vaccination
      this.profile_details[8].value = this.pet_data.isVaccinated ? `YES` : `NO`;
      this.profile_details[8].isPrivate = false;

      // if(this.pet_data.vaccinations && this.pet_data.vaccinations.length > 0){
      //     this.profile_details[8].value = this.pet_data.vaccinations[0].vaccine;
      //     this.profile_details[8].isPrivate = false;
      // }else{
      //     //Vaccinated
      //     this.profile_details[5].value = this.pet_data.isVaccinated
      //         ? `YES`
      //         : `NO`;
      //     this.profile_details[5].isPrivate = false;
      // }

      //gender
      this.filtered_profile_details =
        !this.pet_data.settings_privacy ||
        !this.pet_data.settings_privacy.showAttributes
          ? []
          : this.profile_details.filter((el) => !el.isPrivate && el.value);
      this.actionPending = true;

      // this.profile_details[3].label = this.pet_data.link_instagram ? `${this.pet_data.link_instagram}` : `barkbadge`
      // this.profile_details[3].isPrivate = this.pet_data.settings_privacy.showSocials
      //breed
    },
    getLinesCount() {
      const element = this.$refs.notes;
      if (element) {
        var prevLH = element.style.lineHeight;
        var factor = 1000;
        element.style.lineHeight = factor + "px";
        var height = element.getBoundingClientRect().height;
        element.style.lineHeight = prevLH;
        const lines = Math.floor(height / factor);
        return lines;
      } else {
        return 0;
      }
    },
    shake() {
      if (this.interval_count < 4) {
        this.shakeImgs = true;
        setTimeout(() => {
          this.shakeImgs = false;
        }, 2000);
        this.interval_count = this.interval_count + 1;
      }
    },
  },
  computed: {
    ...mapState(["userID", "pet_data", "current_location"]),
    ...mapGetters(["isAuthenthicated"]),
    aboutPlaceholder() {
      return `Tell everyone about ${this.pet_data.name}! You can talk about things like personality, favorite foods, or even how to contact you in case of an emergency.`;
    },
    userLocationFmt() {
      let location = [];
      if (
        !this.pet_data.settings_privacy ||
        !this.pet_data.settings_privacy.showLocation
      ) {
        return "Hidden";
      }
      if (!this.pet_data.location.address) {
        return "Unknown Location";
      }
      const locationKeys = ["line1", "line2", "city", "province", "postal_code"];
      locationKeys.forEach((idx) => {
        if (this.pet_data.location.address[idx]) {
          location.push(this.pet_data.location.address[idx]);
        }
      });
      if (!(location.length > 0)) {
        return "Unknown Location";
      }
      const full_address = location.join(", ") + " " + this.pet_data.location.address.country;
      return full_address
    },
    triggerAlert: {
      get() {
        const now = new Date();
        const utc_epoch = Math.round(now.getTime() / 1000);
        if (utc_epoch < this.pet_data.alertExpiration) {
          return false;
        } else {
          return true;
        }
      },
      set(value) {
        console.log(value);
        return value;
      },
    },
    displayPetAge() {
      let display_age = "";
      let display_age_postfix = "";
      let from = this.pet_data.bday.split("/");
      let birthdateTimeStamp = new Date(from[2], from[0] - 1, from[1]);
      let cur = new Date();
      let diff = cur - birthdateTimeStamp;
      // This is the difference in milliseconds
      let display_day_age = Math.floor(diff / 86400000); // in days
      // Divide by 1000*60*60*24*365.25
      if (display_day_age < 7) {
        display_age = `${display_day_age}`;
        display_age_postfix = "Day";
      } else if (display_day_age >= 7 && display_day_age < 30) {
        let week_age = Math.floor(display_day_age / 7);
        display_age = `${week_age}`;
        display_age_postfix = "Week";
      } else if (display_day_age >= 30 && display_day_age < 365.25) {
        let month_age = Math.floor(display_day_age / 30);
        display_age = `${month_age}`;
        display_age_postfix = "Month";
      } else if (display_day_age >= 365.25) {
        let year_age = Math.floor(display_day_age / 365.25);
        display_age = `${year_age}`;
        display_age_postfix = "Year";
      }
      return {
        display_age,
        display_age_postfix:
          display_age > 1 ? display_age_postfix + "s" : display_age_postfix,
      };
    },
    displayUser() {
      let d_name = this.userdata.username;
      if (this.userdata.fname != "") {
        d_name = `${this.userdata.fname} ${this.userdata.lname}`;
      }
      return d_name;
    },
  },
  created() {
    this.pets = [];
    
    console.log("🔴 this.pet_data", this.pet_data)
    this.getPetData(this.pet_id);
    if (!this.editablePage) {
      setInterval(() => {
        this.shake();
      }, 5000);
    }
  },
  updated() {
    if (!this.actionPending) {
      this.initPetAttributes();
    }
    // this.notesLines = this.getLinesCount();
  },
};
</script>
<style scoped>
#PetCardSection {
  text-align: center;
  min-height: 35vh;
  width: 100%;
  border: none;
  margin: 0;
  opacity: 1;
  /* margin-top: -8rem; */
  padding-bottom: 6px;
  color: var(--primary);
  position: relative;
  display: flex;
  z-index: 10;
  flex-direction: column;
  transition: 1s;
  font-family: "Altis";
  font-style: normal;
}
#PetCardSection:hover {
  transform: translateY(-3px);
}
.visible-pet-info {
  text-align: left;
}
/*----------------------*\
|     TOP CREDENTIALS
\*----------------------*/
.pet-credentials {
  display: flex;
  flex-direction: column;
  width: 96%;
  margin: auto;
  justify-content: center;
  align-items: center;
  color: #000;
}
.profile-info-card {
  box-sizing: border-box;
  position: relative;
  display: flex;
  top: -4rem;
  width: 90%;
  margin: 2rem auto;
  padding: 1rem;
  /* height: 10.3rem; */
  background: #ffffff;
  box-shadow: 0px 0px 21px 1px rgb(0 0 0 / 9%);
  border-radius: 15px;
  margin-bottom: -4rem;
}
.attributes-header {
  display: flex;
  width: 90%;
  font-size: 0.9rem;
  margin: 1rem auto;
  margin-bottom: -0.4rem;
}
.section-headtext {
  color: #000;
}

.pet-attributes-section {
  position: relative;
  display: flex;
  align-items: center;
  width: 90%;
  height: 72px;
  margin: 1rem auto;
  justify-content: space-around;
  background: #f4f6fa;
  text-transform: capitalize;
  border-radius: 12px;
}
.pet-attributes-devider-left {
  margin-top: 12.5px;
  margin-bottom: 9.5px;
  height: 50px;
  width: 0px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  left: 33.33%;
  position: absolute;
}
.pet-attributes-devider-right {
  margin-top: 12.5px;
  margin-bottom: 9.5px;
  height: 50px;
  right: 33.33%;
  width: 0px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  position: absolute;
}

.pet-attributes-heading {
  font-weight: 800;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  letter-spacing: 2px;
  text-transform: uppercase;
}
.pet-attributes-heading-gray {
  font-weight: 800;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
  vertical-align: top;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #979797 !important;
}
.pet-attributes-value {
  font-size: 18px;
  font-weight: "bolder";
  line-height: 30px;
  text-align: center;
  color: #2d3142 !important;
}
.pet-attributes-value-medium {
  font-weight: "bolder";
  margin-top: 6px;
  font-size: 18px;
  line-height: 30px;
  text-align: left;
  color: #2d3142 !important;
}

.pet-attributes-value small {
  font-weight: "bolder" !important;
  font-size: 12px !important;
}
.profile-details {
  width: 96%;
  margin: auto;
  min-height: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 1rem;
  transition: 1s;
  position: relative;
}
.report-lost-btn {
  cursor: pointer;
  background: rgba(220, 114, 103, 1);
  margin-top: 0.5rem;
  padding: 14px 0;
  border-radius: 88px;
  width: 100%;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  color: #ffffff;
  text-transform: uppercase;
}
.processing-report {
  cursor: not-allowed;
  background: #c4c4c4;
}
.btn-group {
  width: 80%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.gv-btn-group {
  width: 50%;
}
.profile-image-group {
  position: relative;
  width: 25%;
}
.profile-address-group {
  display: flex;
}
.profile-image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  height: calc(100% - 1rem) !important;
  width: 100%;
  border-radius: 12px;
  margin-bottom: 1rem;
  position: relative;
}
.profile-image-country {
  background-position: center;
  position: absolute;
  height: 34px;
  width: 32px;
  background-size: cover;
  background-repeat: no-repeat;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  border: 3.5px solid #fff;
  border-radius: 12px;
}
.text-primary {
  margin-left: 0.4rem;
}
.notes-more-less {
  color: #6266f0;
  cursor: pointer;
}
.tag-icons {
  position: absolute;
  z-index: 11;
  width: 2.3rem;
  right: -0.5rem;
  padding: 0;
  margin: 0;
  border: 3px solid var(--bg-default);
  bottom: 1rem;
  border-radius: 100%;
  transition: 0.5s ease;
}
.profile-input:hover .profile-img-overlay {
  opacity: 1;
  cursor: pointer;
}
.profile-image .profile-img-overlay {
  background-color: var(--bg-dark);
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  transform: translateY(-100%);
  border-radius: 100%;
  padding: 0rem;
  /* -ms-transform: translate(-50%, -50%); */
}
.profile-image .profile-img-overlay p {
  color: #fff;
  position: absolute;
  top: 50%;
  left: 20%;
  font-size: 0.6rem;
}
.profile-image .profile-input {
  cursor: pointer;
  border: 2px solid #777;
  position: absolute;
  background-color: var(--bg-dark);
  transition: 0.5s ease;
  border-radius: 100%;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  z-index: 10;
}
/*----------------------*\
|  PROFILE IMAGE END
\*----------------------*/
.subtext {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin: 0.7rem auto;
  transition: 1s ease;
}
.no-age-text {
  margin: 0 0.3rem;
}
.location-text {
  font-weight: bold;
}
.address-icon {
  margin-right: 0.3rem;
  width: 14px;
  margin-top: 0.1rem;
}
.profile-details-section {
  width: 75%;
  padding: 0px 10px;
  justify-content: space-between;
  flex-direction: column;
  display: flex;
  box-sizing: border-box;
}
.profile-details-name {
  width: 100%;
  /* margin-left: 2.5rem; */
  margin: 0 auto;
  text-align: start;
  margin-bottom: 0rem;
  transition: 1s;
  color: #4c5980;
}
.profile-details-address {
  display: flex;
  justify-content: left;
  text-align: left;
  align-items: flex-start;
}
.profile-details-address p {
  line-height: 16px !important;
  font-size: 12px !important;
}
.address-text-truncate {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.profile-details-name h2 {
  font-size: 18px;
  line-height: 24px;
  display: flex;
  font-weight: 900 !important;
  align-items: center;
  color: #01040d;
}
.header-small-text {
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #01040d;
}
.profile-details-name p {
  font-weight: 400;
  font-size: 14px;
  display: flex;
  align-items: center;
  color: #75818f;
}

.profile-details-name p .parent {
  line-height: 22px;
}

.profile-details-name p .owner-name {
  color: #6266f0;
}
.profile-details-location {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  border-radius: 2px;
  transition: 1s;
  margin: 1rem;
  color: #4c5980;
}

.edit-allergies img {
  width: 1.6rem;
  height: 1.6rem;
  margin-right: 1rem;
  transition: 1s;
}
.visibility-popup {
  background-color: #fff;
  border: 2px solid #000;
  border-radius: 6px;
  width: 100%;
  height: 3rem;
  font-family: "Altis";
  font-size: 12px;
  padding: auto 0.6rem;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: -2;
  transition: 0.5s;
  opacity: 0;
}
.visibility-active {
  opacity: 1;
  z-index: 2;
  transform: translateY(-3rem);
}
.allery-btn-group {
  width: 100%;
  margin: 0;
  margin-top: 1rem;
  text-align: center;
  display: flex;
  justify-content: center;
}
.allergy-pod {
  background: var(--health);
  border: none;
  color: #000;
  outline: none;
  cursor: pointer;
  font-size: 14px;
  margin: 0;
  width: 90%;
  height: 40px;
  padding: 10px 20px;
  border-radius: 10px;
  position: relative;
  transition: 1s;
}
.about-section {
  text-align: left;
  width: 90%;
  line-height: 24px;
  margin: 1rem auto;
  margin-bottom: 0;
  position: relative;
  transition: 1s;
}
.about-screen {
  position: absolute;
  z-index: 5;
  background: #000;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: not-allowed;
}
.pet-notes {
  color: #333 !important;
  width: 96%;
  resize: none;
  outline: none;
  min-height: 1.5rem;
  border: none;
  font-family: "Altis";
  font-size: 15px;
  border-radius: 12px;
  margin-top: 5px;
  background-color: #fff;
  transition: 1s;
}
.special-text {
  margin: 0 0.2rem;
}
.gv-notes {
  min-height: 1.5rem;
}
.gv-notes p {
  color: #777;
}
.about-section .active {
  background-color: #f5f5f5;
}
.about-section textarea[placeholder] {
  color: #777 !important;
  /* font-size: 15px; */
  padding: 0.4rem;
}
.about-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.about-header-text {
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #01040d;
  font-size: 18px;
}
.edit-about {
  width: 1.2rem;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  transition: 1s;
}
.edit-about img {
  width: 100%;
}
.x-close {
  font-size: 2rem;
}
.allergy-pod-text {
  color: #fff;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  font-weight: bold;
}
.allergy-pod img {
  width: 1.5rem;
  margin-right: 0.5rem;
}
.public-pod {
  background: var(--primary);
}
.private-pod {
  background: rgb(155, 159, 164);
}
/*---------------------------*\
|            ABOUT PET
\*---------------------------*/
.no-notes {
  color: #aaa;
}
/*---------------------------*\
|            PET GRID
\*---------------------------*/

.width-90 {
  width: 90%;
  margin: 0 auto;
  margin-bottom: 1rem;
}
.pet-grid {
  /* padding-top:1rem; */
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  justify-items: stretch;
  align-items: stretch;
  transition: 1s;
  padding: 0.8rem 1rem;
}
.border-grey {
  border: 1px solid #eaeefc !important;
  border-radius: 12px !important;
}
.pet-info {
  display: flex;
  background-color: #f9f9f9;
  border-radius: 6px;
  padding: 0.5rem 1rem 1rem 1.4rem;
  justify-content: flex-start;
  color: #000;
  cursor: pointer;
  align-items: center;
}
.bg-white {
  background-color: white !important;
}
.pet-info:hover {
  background-color: #e9e9e9;
}
.save-btn {
  font-size: 14px !important;
  height: 2.1rem;
}
.btn-group-full-width {
  width: 90%;
  margin: 0 auto;
  margin-bottom: 10px;
}
.btn-full-width {
  align-items: center;
  justify-content: space-between;
  display: flex;
  border-radius: 12px;
  color: white;
  height: 52px;
  cursor: pointer;
}
.btn-instagram {
  background-color: #6266f0;
}
.btn-tiktok {
  background-color: #000000;
}
.btn-health {
  background-color: var(--health);
}
.btn-section {
  display: flex;
  justify-content: left;
  height: 100%;
  align-items: center;
}
.btn-left-text {
  align-items: center;
}
.btn-left-text p {
  text-align: left;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
}
.btn-left-text h2 {
  font-size: 1rem;
  font-weight: 500;
  line-height: 20px;
}
.btn-section .icon {
  width: 60px;
  margin: auto;
  align-items: center;
  justify-content: center;
  display: flex;
}

.link {
  color: var(--primary);
  text-decoration: underline;
}
.pet-info img {
  width: 1.5rem;
  margin-right: 0.6rem;
}
.edit-mode {
  /* Start the shake animation and make the animation last for 0.5 seconds */
  animation: shake 1s;
  /* When the animation is finished, start again */
  animation-iteration-count: infinite;
}
.action-btns {
  margin-top: 45%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: row;
}
.action-btns button {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  background-color: transparent;
  border: 5px solid #777;
  margin: 0.5rem;
  border-radius: 10px;
  transition: 1s;
}
.action-btns button:hover {
  transform: translateY(-10px);
  cursor: pointer;
}

.action-btns button .icon {
  width: 2.4rem;
  height: 2.4rem;
  margin: 1rem;
  transition: 1s;
}
/*----------------------*\
|  PROFILE IMAGE END
\*----------------------*/
.more-options {
  border: 0.7px solid #c7cad9;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 1rem;
  width: 60px;
  height: 40px;
  right: 3rem;
  background: transparent;
  z-index: 20;
  transition: 1s;
}
.more-options img {
  width: 2rem;
}
.more-menu-overlay {
  background-color: #999;
  position: absolute;
  width: 100vh;
  height: 100vh;
  top: -1rem;
  left: -1rem;
  z-index: 15;
  opacity: 0;
}
.more-menu-area {
  position: relative;
}
.more-icon-menu {
  position: absolute;
  transition: 1s;
  opacity: 1;
  width: 250%;
  max-height: 9rem;
  z-index: 19;
  top: -6rem;
  right: -1rem;
  transform: scale(0.1);
  border: 0.7px solid #c7cad9;
  padding: 0.8rem;
  border-radius: 10px;
  transition: 1s;
  background-color: #ffffff;
}
.menu-open .more-icon-menu {
  top: -300%;
  right: 2.5rem;
  transform: scale(1);
  opacity: 1;
}
.guest-menu {
  top: -100% !important;
}
.more-icon-menu ul {
  list-style-type: none;
  text-align: left;
}
.more-icon-menu ul li {
  margin: 0.6rem 0;
  padding: 0.1rem;
  color: var(--link-light);
  cursor: pointer;
}
.delete-link {
  color: #ec1a52 !important;
  transition: 1s;
}
.text-ellipsis--6 {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.delete-link:hover {
  opacity: 0.6;
  background-color: #ddd;
}

/* ACcOUNT SETTINGS */
.contact-settings {
  margin: 3rem auto;
  /* text-align:center; */
}
.setting-option {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.rememberme-group {
  display: flex;
  position: relative;
}
.rememberme-wrapper {
  border-radius: 30px;
  width: 4rem;
  height: 1.3rem;
  margin-left: 0.3rem;
  background-color: #ddd;
  border: 1px solid #ddd;
  position: relative;
  transition: 1s ease;
}
.rememberme-ball {
  position: absolute;
  left: 0;
  border-radius: 100%;
  width: 1.3rem;
  height: 1.3rem;
  transition: 1s ease;
  background-color: #fff;
}
.selected-wrapper {
  background-color: var(--link-light);
  border-color: var(--link-light);
}
.selected {
  left: 70%;
}
.input-checkbox {
  opacity: 0;
  position: absolute;
  right: 0;
  z-index: 3;
  width: 100%;
  height: 1.3rem;
  cursor: pointer;
}
/*----------------------*\
|  PET ALERT AREA
\*----------------------*/
.alert-area {
  display: flex;
  justify-content: space-evenly;
}
.red-alert {
  font-family: "Altis";
  width: 100%;
  min-width: 10rem;
  margin: 0 auto;
  /* margin-top: 1rem; */
  color: #fff;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: bold;
  border: none;
  display: flex;
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  padding: 0.8rem 0.8rem;
  cursor: pointer;
  background-color: #c10600;
}
.unactive,
.unactive2 {
  outline: none;
  color: var(--primary);
  cursor: not-allowed;
  background-color: #e7e8fe;
}
.unactive2 {
  cursor: pointer;
}
.red-alert img {
  width: 1.6rem;
  margin-right: 1rem;
}
/* ALLERGIES POD */
.allergy-pods {
  margin: auto;
  width: 80%;
  margin-top: -1.2rem;
  min-width: 10rem;
  margin-left: 0.5rem;
}
.allergy-pods-group {
  display: flex;
  width: 90%;
  margin: 1rem auto;
}
.prg-wrap {
  flex-wrap: wrap;
}
.prg-shift {
  margin-left: 1rem;
}
.allergy-pod-2 {
  background-color: var(--health);
  padding: 0.3rem 0.6rem;
  margin: 0.2rem 0.2rem;
  font-size: 0.7rem;
  border-radius: 15px;
  color: #fff;
}
.size-reduce {
  font-size: 0.88rem;
}
body[data-theme="dark"] #PetCardSection,
body[data-theme="dark"] .more-icon-menu {
  background-color: #333;
  color: #fff;
}
body[data-theme="dark"] .pet-grid,
body[data-theme="dark"] .pet-grid a {
  color: #fff;
}
body[data-theme="dark"] .profile-details-name,
body[data-theme="dark"] h4,
body[data-theme="dark"] .profile-details-location p {
  color: #fff;
}

@-webkit-keyframes rotate-center {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotate-center {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes shake {
  0% {
    transform: translate(0.5px, 0.5px) rotate(0deg);
  }
  10% {
    transform: translate(-0.5px, -1px) rotate(-1deg);
  }
  20% {
    transform: translate(-1px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  40% {
    transform: translate(0.5px, -0.5px) rotate(1deg);
  }
  50% {
    transform: translate(-0.5px, 1px) rotate(-1deg);
  }
  60% {
    transform: translate(-1px, 0.5px) rotate(0deg);
  }
  70% {
    transform: translate(1px, 0.5px) rotate(-1deg);
  }
  80% {
    transform: translate(-0.5px, -0.5px) rotate(1deg);
  }
  90% {
    transform: translate(0.5px, 1px) rotate(0deg);
  }
  100% {
    transform: translate(0.5px, -1px) rotate(-1deg);
  }
}
/* END ACcOUNT SETTINGS */
@media only screen and (max-width: 600px) {
  .red-alert {
    font-size: 10px;
  }
  .allergy-pod {
    max-width: 8rem;
  }
  #PetCardSection {
    min-height: 11rem;
  }
  /**
  .profile-image{
    width: 7rem;
    height: 7rem;
    top: .5rem;
    border: 2px solid var(--bg-default);
  }
  **/

  .tag-icons {
    width: 1.5rem;
    right: -0.5rem;
    bottom: 0.2rem;
  }
  .allergy-pod img {
    width: 1rem;
  }
  .pet-info img {
    width: 1rem;
    margin-right: 0.6rem;
  }
  .pet-info {
    font-size: 0.9rem;
    padding: 5px;
  }
  .more-options img {
    width: 1.5rem;
  }
  /* .more-icon-menu{right: 2.5rem;} */
  .red-alert img {
    width: 1rem;
  }
}
</style>
